import React from "react";

const POSContext = React.createContext();

export const POSProvider = POSContext.Provider;
export const POSConsumer = POSContext.Consumer;

export default POSContext;